

<div class="container container-fullsize">
    
  <div class="row">
  <div class="col card ">

  <div class="col mt-2">
    <h4 class="card-title text-center float-center"> Parametrizações Administrativas</h4>
    <div class="text-center float-center">
      <a (click)="iniciarEleicoesAutomaticamente()" class="text-info" style="cursor: pointer;"><i class="far fa-paper-plane mr-1"></i>Iniciar eleições automaticamente</a>
      <span class="text-info mx-4"> | </span>
      <a (click)="iniciarCandidaturasAutomaticamente()" class="text-info" style="cursor: pointer;"><i class="far fa-paper-plane mr-1"></i>Iniciar candidaturas</a>
      <span class="text-info mx-4"> | </span>
      <a (click)="iniciarAprovacaoAutomaticamente()" class="text-info" style="cursor: pointer;"><i class="far fa-paper-plane mr-1"></i>Iniciar aprovação</a>
      <span class="text-info mx-4"> | </span>
      <a (click)="cadastrarNovoGestor()" class="text-info" style="cursor: pointer;"><i class="far fa-edit mr-1"></i>Cadastrar novo gestor</a>
      <br>
      <a (click)="buscarPlataformas()" class="text-info" style="cursor: pointer;" data-toggle="modal" data-target="#modalPlataformas"><i class="far fa-edit mr-1"></i>Plataformas</a>
      <span class="text-info mx-4"> | </span>
      <a (click)="logout()" class="text-danger" style="cursor: pointer;"><i class="fas fa-times mr-1"></i>Sair</a>
    </div>
  </div>
  <br>
  <h4 class="card-title text-center float-center"> Gestores </h4>
  <table class="table">
    <thead>
      <tr>
        <th>
          NOME
        </th>
        <th>
          E-MAIL
        </th>
        <th>
          CPF
        </th>
        <th>
          ELEIÇÕES
        </th>
        <th>
          SENHA
        </th>
        <th>
          ASSISTENTES
        </th>
        <th>
          STATUS
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let gestor of listaDeGestores">
        <td>
          <strong>{{gestor.nome}}</strong> 
        </td>
        <td>
          {{gestor.login}} 
        </td>
        <td>
          {{gestor.cpf}} 
        </td>
        <td (click)="buscarEleicoesPorId(gestor.id)" data-toggle="modal" data-target="#modalEleicoes">
          <button type="button" class="btn-sm btn-primary" >VISUALIZAR</button>
        </td>
        <td>
          <button type="button" (click)="abrirModalSenha(gestor.id)" class="btn-sm btn-primary" data-toggle="modal" data-target="#modalSenha">ALTERAR</button>
        </td>
        <td>
          <button type="button" (click)="buscarAssistentesPorId(gestor.id)" class="btn-sm btn-primary" data-toggle="modal" data-target="#modalAssistentes">EDITAR</button>
        </td>
        <td>
          <button type="button" (click)="alterarSituacaoDoGestor(gestor.id,gestor.ativo)" [ngClass]="{'btn-sm btn-danger':gestor.ativo==true,'btn-sm btn-success':gestor.ativo==false}" >{{gestor.ativo==true?'SUSPENDER':'HABILITAR'}}</button>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- MODAL ELEIÇÕES DO GESTOR-->
  <div id="modalEleicoes" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <!-- HEADER -->
        <div class="modal-header">
          <h5 class="modal-title">Eleições do gestor </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- BODY -->
        <div class="modal-body">
          <table  class="table">
            <thead>
              <th>
                TÍTULO
              </th>
              <th>
                SITUAÇÃO
              </th>
              <th>
                AUTENTICAÇÃO VIA
              </th>
              <th>              
                INICIADA EM
              </th>
              <th>              
                FINALIZADA EM
              </th>
            </thead>
            <tbody>
              <tr *ngFor="let eleicao of listaDeEleicoes">
                <td>
                  <b>{{eleicao.titulo}}</b>
                </td>
                <td [ngClass]="{'green':eleicao.statusEleicao == 'CRIADA' || eleicao.statusEleicao=='Em andamento',
                                'red':eleicao.statusEleicao=='Cancelada' || eleicao.statusEleicao=='Parada',
                                'blue':eleicao.statusEleicao=='Prorrogada' || eleicao.statusEleicao=='Encerrada' || eleicao.statusEleicao=='Aguardando Apuração' || eleicao.statusEleicao=='Apurada'}">
                  {{eleicao.statusEleicao}}
                </td>
                <td>
                  {{eleicao.tipoautentificacao}}
                </td>
                <td>
                  {{ eleicao.dataHoraInicio | date: 'dd/MM/yyyy' }}
                </td>
                <td>
                  {{ eleicao.dataHoraFim | date: 'dd/MM/yyyy' }}
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <!-- FOOTER -->
        <div class="modal-footer">
          <!-- <button type="button" class="btn btn-success btn-sm">SALVAR</button> -->
          <!-- <button type="button" class="btn btn-danger" data-dismiss="modal">FECHAR</button> -->
        </div>

      </div>
    </div>
  </div>
  <!-- -------------------------------------------------------------------------------------- -->

  <!-- MODAL ASSISTENTES DO GESTOR-->
  <div id="modalAssistentes" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <!-- HEADER -->
        <div class="modal-header" *ngIf="!semAssistentes">
          <h5 class="modal-title">Assistentes do gestor </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- BODY -->
        <div class="modal-body" *ngIf="!semAssistentes">
          <table  class="table">
            <thead>
              <th>
                NOME
              </th>
              <th>
                E-MAIL
              </th>
              <th>
                CPF
              </th>
              <th>              
                SENHA
              </th>
              <th>
                STATUS
              </th>
            </thead>
            <tbody>
              <tr *ngFor="let assistente of listaDeAssistentes">
                <td>
                  <b>{{assistente.nome}}</b>
                </td>
                <td>
                  {{assistente.login}}
                </td>
                <td>
                  {{assistente.cpf}}
                </td>
                <td>
                  <button type="button" (click)="abrirModalSenhaAssistente(assistente.id)" class="btn-sm btn-primary" data-toggle="modal" data-dismiss="modal" data-target="#modalSenhaAssistente">ALTERAR</button>
                </td>
                <td>
                  <button type="button" (click)="alterarSituacaoDoAssistente(assistente.id,assistente.ativo)" [ngClass]="{'btn-sm btn-danger':assistente.ativo==true,'btn-sm btn-success':assistente.ativo==false}" >{{assistente.ativo==true?'SUSPENDER':'HABILITAR'}}</button>
                </td>                
              </tr>
            </tbody>
          </table>

        </div>
        <div class="modal-body" *ngIf="semAssistentes">
          <div class="row d-flex text-center align-items-center mt-3 mb-5">
            <div class="col-md-12">
              <h4>Ainda não existem assistentes para esse gestor. <br>Clique abaixo para cadastrar.</h4>
            </div>
          </div>
        </div>
        <!-- FOOTER -->
        <div class="modal-footer">
          <button type="button" (click)="cadastrarNovoAssistente(gestor.id)" class="btn btn-success btn-sm" data-dismiss="modal">CADASTRAR NOVO ASSISTENTE</button> 
          <!-- <button type="button" class="btn btn-danger" data-dismiss="modal">FECHAR</button> -->
        </div>

      </div>
    </div>
  </div>
  <!-- -------------------------------------------------------------------------------------- -->
  
  <!-- MODAL ALTERAÇÃO DE SENHA -->
  <div id="modalSenha" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <!-- HEADER -->
        <div class="modal-header">
          <h5 class="modal-title">Alteração de senha</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- BODY -->
        <div class="modal-body">
          <form role="form" [formGroup]="formGroup">
            <div class="container">
              <div class="row">
                <div class="col-md-6">
                  <input [(ngModel)]="senha" class="form-control ext-input p-4" placeholder="Digite aqui a nova senha" 
                  type="password" formControlName="senha" >
                </div>
                <div class="col-md-6">
                  <input [(ngModel)]="confirmacaoSenha" class="form-control ext-input p-4" placeholder="Confirme a nova senha" 
                  type="password" formControlName="confirmacaoSenha" >
                </div>
              </div>
              <div class="row mx-2">
                <span *ngIf="senha != confirmacaoSenha" class="error" style="color: red"> As senhas devem ser iguais!!! </span>
              </div>
              <p *ngIf="password" class="mb-0 mt-2"><strong>{{password}}</strong></p>
              <div class="row px-0">
                <div class="col-12 d-flex justify-content-end">
                  <button (click)="alterarSenhaGestor(gestorModalSelecionado)" data-dismiss="modal" class="btn btn-success btn-custom mx-2 mt-3"> SALVAR </button>
                </div>
              </div>
            </div>
          </form>
          </div>
        <!-- FOOTER
        <div class="modal-footer">
        </div> -->

      </div>
    </div>
  </div>
  <!-- MODAL ALTERAÇÃO DE SENHA DO ASSISTENTE-->
  <div id="modalSenhaAssistente" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <!-- HEADER -->
        <div class="modal-header">
          <h5 class="modal-title">Alteração de senha</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- BODY -->
        <div class="modal-body">
          <form role="form" [formGroup]="formGroup">
            <div class="container">
              <div class="row">
                <div class="col-md-6">
                  <input [(ngModel)]="senha" class="form-control ext-input p-4" placeholder="Digite aqui a nova senha" 
                  type="password" formControlName="senha" >
                </div>
                <div class="col-md-6">
                  <input [(ngModel)]="confirmacaoSenha" class="form-control ext-input p-4" placeholder="Confirme a nova senha" 
                  type="password" formControlName="confirmacaoSenha" >
                </div>
              </div>
              <div class="row mx-2">
                <span *ngIf="senha != confirmacaoSenha" class="error" style="color: red"> As senhas devem ser iguais!!! </span>
              </div>
              <p *ngIf="password" class="mb-0 mt-2"><strong>{{password}}</strong></p>
              <div class="row px-0">
                <div class="col-12 d-flex justify-content-end">
                  <button (click)="alterarSenhaAssistente(assistenteModalSelecionado)" data-dismiss="modal" class="btn btn-success btn-custom mx-2 mt-3"> SALVAR </button>
                </div>
              </div>
            </div>
          </form>
          </div>
        <!-- FOOTER
        <div class="modal-footer">
        </div> -->

      </div>
    </div>
  </div>
<!-- MODAL PLATAFORMAS CRUD-->
<div id="modalPlataformas" class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <!-- HEADER -->
      <div class="modal-header">
        <h5 class="modal-title">Plataformas</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- BODY -->
      <div class="modal-body">
        <table  class="table">
          <thead>
            <th>
              Nome
            </th>
            <th>
              UsernameKeyParam
            </th>
            <th>
              PasswordKeyParam
            </th>
            <th>              
              Criada em
            </th>
            <th>              
              Alterada em
          </th>
          </thead>
          <tbody>
            <tr *ngFor="let plataforma of listaPlataformas">
              <td>
                <b>{{plataforma.nome}}</b>
              </td>
              <td>
                {{plataforma.usernameKeyParam}}
              </td>
              <td>
                {{plataforma.passwordKeyParam}}
              </td>
              <td>
                {{ plataforma.createdAt | date: 'dd/MM/yyyy' }}
              </td>
              <td>
                {{ plataforma.updateAt | date: 'dd/MM/yyyy' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- FOOTER -->
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-success btn-sm">SALVAR</button> -->
        <!-- <button type="button" class="btn btn-danger" data-dismiss="modal">FECHAR</button> -->
      </div>
    </div> 
  </div>
  </div>
   

  
</div>
</div> 
</div>






  

  <!-- -------------------------------------------------------------------------------------- -->
